/**
 * Routes with React components
 *
 * For code that DOESN'T need components (most cases):
 * - Import from "@lib/routes.config" (Storybook-safe)
 *
 * For code that NEEDS components (React Router only):
 * - Import Routes/StudentRoutes from "@lib/routes" (this file)
 */

import ActivityPlayer from "@views/activity";
import Classrooms from "@views/classrooms";
import CurriculumResources from "@views/curriculum-resources";
import MultiOrgDashboard from "@views/dashboard/dashboard.multi";
import SingleOrgDashboard from "@views/dashboard/dashboard.single";
import Devices from "@views/devices";
import Integrations from "@views/integrations";
import MyWork from "@views/my-work";
import Organizations from "@views/organizations";
import Profile from "@views/profile/profile";
import Programs from "@views/programs";
import Users from "@views/users";

// Re-export all route configurations for backward compatibility
export * from "./routes.config";

// Import configs to use for mapping
import * as RouteConfigs from "./routes.config";

/**
 * Component mapping for routes
 */
const ComponentRouteMap = {
  MultiOrgDashboardRoute: MultiOrgDashboard,
  SingleOrgDashboardRoute: SingleOrgDashboard,
  OrgsRoute: Organizations,
  UsersRoute: Users,
  ClassroomRoute: Classrooms,
  ProgramsRoute: Programs,
  ProfileRoute: Profile,
  MyWorkRoute: MyWork,
  DevicesRoute: Devices,
  IntegrationsRoute: Integrations,
  CurriculumResourcesRoute: CurriculumResources,
  ActivityPlayerRoute: ActivityPlayer,
};

/**
 * Helper to add components to route configs
 */
const addComponentsToRoutes = (routeConfigs) => {
  return routeConfigs.map((route) => {
    const routeKey = Object.keys(RouteConfigs).find(
      (key) => RouteConfigs[key] === route
    );

    if (routeKey && ComponentRouteMap[routeKey]) {
      return {
        ...route,
        component: ComponentRouteMap[routeKey],
      };
    }

    // Return as-is for external links
    return route;
  });
};

/**
 * Routes with components for React Router
 */
export const Routes = addComponentsToRoutes([
  RouteConfigs.MultiOrgDashboardRoute,
  RouteConfigs.SingleOrgDashboardRoute,
  RouteConfigs.OrgsRoute,
  RouteConfigs.UsersRoute,
  RouteConfigs.ClassroomRoute,
  RouteConfigs.ProgramsRoute,
  RouteConfigs.ProfileRoute,
  RouteConfigs.SupportRoute,
  RouteConfigs.CurricularRoute,
  RouteConfigs.ProductCatalogRoute,
  RouteConfigs.DevicesRoute,
  RouteConfigs.IntegrationsRoute,
  // RouteConfigs.FundingRoute,
  RouteConfigs.CurriculumResourcesRoute,
  RouteConfigs.MyWorkRoute,
  RouteConfigs.ActivityPlayerRoute,
]);

export const StudentRoutes = addComponentsToRoutes([
  RouteConfigs.MyWorkRoute,
  RouteConfigs.ActivityPlayerRoute,
  RouteConfigs.TrekRoute,
  RouteConfigs.ProfileRoute,
]);
